
import { defineComponent, ref, reactive, toRefs, onMounted, watch, nextTick, onUnmounted } from 'vue'
import { DoubleRightOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
import api from '@/api/allApi'
import { init, ECharts, EChartsOption } from 'echarts'
export default defineComponent({
  props: {
    id: {
      type: String,
      default: () => {
        return ''
      }
    },
    colorList: {
      type: Object,
      default: () => {
        return {}
      }
    },
    option: {
      type: Object,
      default: () => {
        return {}
      }
    },
    theme: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  setup(props, context) {
    const pageData: any = reactive({
      // myChart: {}
    })

    let myChart: any = reactive({})
    const color = ['#005EFF', '#FF9900', '#62D599', '#EB569B', '#00DDFF', '#BB00BB', '#8397BC', '#E86452', '#FFCC0D', '#FFCC0D']
    const route = useRoute()
    const theme = props.theme || route.query.theme
    function setoption(option: any) {
      const _option: any = option
      nextTick(() => {
        myChart.setOption(_option, true)
      })
    }
    function resizecharts() {
      myChart.resize()
    }
    onMounted(() => {
      nextTick(() => {
        if (!props.id) return
        const dom: any = document.getElementById(props.id)
        myChart = init(dom)
        setoption(props.option)
        // 监听
        // window.addEventListener('resize', resizecharts)
      })
    })
    onUnmounted(() => {
      // window.removeEventListener('resize', resizecharts)
    })
    watch(
      () => props.option,
      (val: any) => {
        nextTick(() => {
          const _option = val
          if (Object.keys(_option || {}).length < 1) return
          const max = (((_option || {}).yAxis || [])[0] || {}).max || null
          let splitLine = {
            lineStyle: {
              color: '#DBDFE6'
            }
          }
          let axisLine = {
            lineStyle: {
              color: '#7D7D7D'
            }
          }
          const axisTick = {
            show: false
          }
          if (theme === 'dark') {
            splitLine = {
              lineStyle: {
                color: '#252A34'
              }
            }
            axisLine = {
              lineStyle: {
                color: '#7D7D7D'
              }
            }
          }
          if (_option.xAxis && _option.xAxis.constructor === Array && (_option.xAxis || []).length) {
            _option.xAxis.forEach((item: any) => {
              item.axisLine = axisLine
              item.axisTick = axisTick
            })
          }
          if (_option.xAxis && _option.xAxis.constructor !== Array) {
            _option.xAxis.axisLine = axisLine
            _option.xAxis.axisTick = axisTick
          }
          if (!_option.legend) _option.legend = {}
          _option.legend.icon = _option.legend.icon ? _option.legend.icon : 'rect'
          _option.legend.itemWidth = _option.legend.itemWidth ? _option.legend.itemWidth : 8
          _option.legend.itemHeight = _option.legend.itemHeight ? _option.legend.itemHeight : 8
          if (!_option.legend.textStyle) _option.legend.textStyle = {}
          _option.legend.textStyle.color = Object.keys(props.colorList).length > 0 ? props.colorList.color : '#7D7D7D'
          if (theme === 'dark') {
            _option.legend.textStyle.color = Object.keys(props.colorList).length > 0 ? props.colorList.color : '#7D7D7D'
          }
          if (_option.yAxis && _option.yAxis.constructor === Array && (_option.yAxis || []).length) {
            _option.yAxis.forEach((item: any, i: number) => {
              item.splitLine = item.splitLine ? item.splitLine : splitLine
              item.axisLine = item.axisLine ? item.axisLine : axisLine
              if (!item.axisLabel) item.axisLabel = {}
              item.axisLabel.formatter = item.axisLabel.formatter
                ? item.axisLabel.formatter
                : function (value: any, index: any) {
                  if (i === 0 && max) {
                    if (max) {
                      if (Math.abs(max) >= 100000000 && value !== 0) {
                        return (value / 100000000).toFixed(2) + '亿'
                      } else if (Math.abs(max) >= 10000 && value !== 0) {
                        return (value / 10000).toFixed(2) + '万'
                      } else {
                        return value
                      }
                    }
                  } else {
                    if (Math.abs(value) >= 100000000) {
                      return (value / 100000000).toFixed(2) + '亿'
                    } else if (Math.abs(value) >= 10000) {
                      return (value / 10000).toFixed(2) + '万'
                    } else {
                      return value
                    }
                  }
                }
            })
          }
          if (_option.yAxis && _option.yAxis.constructor !== Array) {
            _option.yAxis.axisLine = _option.yAxis.axisLine ? _option.yAxis.axisLine : axisLine
            _option.yAxis.axisTick = _option.yAxis.axisTick ? _option.yAxis.axisTick : axisTick
            if (!_option.yAxis.axisLabel) _option.yAxis.axisLabel = {}
            _option.yAxis.axisLabel.formatter = _option.yAxis.axisLabel.formatter
              ? _option.yAxis.axisLabel.formatter
              : function (value: any, index: any) {
                if (max) {
                  if (Math.abs(max) >= 100000000) {
                    return (value / 100000000).toFixed(2) + '亿'
                  } else if (Math.abs(max) >= 10000) {
                    return (value / 10000).toFixed(2) + '万'
                  } else {
                    return value
                  }
                } else {
                  if (Math.abs(value) >= 100000000) {
                    return (value / 100000000).toFixed(2) + '亿'
                  } else if (Math.abs(value) >= 10000) {
                    return (value / 10000).toFixed(2) + '万'
                  } else {
                    return value
                  }
                }
              }
          }
          if (!_option.tooltip) _option.tooltip = {}
          _option.tooltip.backgroundColor = _option.tooltip.backgroundColor ? _option.tooltip.backgroundColor : 'rgba(255,255,255,0.9)'
          if (!(_option || {}).grid) {
            _option.grid = {
              left: 12,
              right: 12,
              bottom: 40,
              top: 30,
              containLabel: true
            }
          }
          setoption(_option)
        })
      },
      { immediate: true }
    )
    return {
      ...toRefs(pageData)
    }
  }
})
